module.exports = __webpack_public_path__ + "media/images/gifts/cook/sug_cozinhar_6-b5e17c5eca489f67c5405c6241fd02c8.jpg";